<ng-container *ngIf="showLoading">
    <div class="loading-spinner">
        <div class="large progress" alt="Loading..." >
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
</ng-container>
<div *ngIf="singleCard && !showProgramCard && codes.length == 0" class="message noGameContainer">
    <p tabindex="0" class="text-center mt-32 mb-16">We're sorry, but this game is currently not available.</p>
</div>
<div id="gameGridComponent" *ngIf="showProgramCard">
    <div *ngIf="!singleCard && showProgramCard" role="heading" id="playEarnTitle" aria-level="2" class="game-grid-title title-md-bold mt-3 mb-1">{{gamesHeading}}</div>
    <div *ngIf="!singleCard && showProgramCard" class="game-title pb-1 color-neutral-700">{{gamesSub}}</div>

    <div class="game-grid" [attr.aria-role]="singleCard ? '' : 'list'" [attr.aria-label]="singleCard ? '':'list of available games'">
        <ng-container *ngIf="activeMode == 'normal'">
            <ng-container *ngIf="showProgramCard && !showLoading">
                <div *ngIf="!singleCard && codes.length == 0" tabindex="0" class="message noGameContainer">
                    <p class="noGameImg text-center mt-32 mb-16 p-16"><img src="/content/dam/games/trophy.svg"></p>
                    <p class="noGameMessage text-center title-md-bold center">We're sorry, no games are currently available in this store.</p>
                    <p class="noGameMessage text-center title-md-bold center">Check back later for more exciting opportunities to win!</p>
                </div>
                <div *ngIf="singleCard && codes.length == 0" class="message noGameContainer">
                    <p tabindex="0" class="text-center mt-32 mb-16">We're sorry, but this game is currently not available.</p>
                </div>

                <ng-container *ngFor="let storeProgram of programData.storePrograms; let i = index">
                    <game-card [ngClass]="{ 'single-card': singleCard }" [singleCard]="singleCard" [game]="storeProgram" [validStore]="true" [optInStatus]="optInStatus" [howItWorksNewUser]="howItWorksNewUser" [howItWorksExistingUser]="howItWorksExistingUser" [sweepstakesEntriesInfo]="sweepstakesEntriesInfo" [programRulesLink]="programRulesLink" [programFAQLink]="programFAQLink" [tokenLabelSingular]="storeProgram.tokenLabelSingular" [tokenLabelPlural]="storeProgram.tokenLabelPlural" [userInfo]="userInfo"></game-card>
                </ng-container>
                <ng-container *ngFor="let userOptedInProgram of programData.userOptedInPrograms; let i = index">
                    <game-card [ngClass]="{ 'single-card': singleCard }" [singleCard]="singleCard" [game]="userOptedInProgram" [validStore]="false" [optInStatus]="optInStatus" [howItWorksNewUser]="howItWorksNewUser" [howItWorksExistingUser]="howItWorksExistingUser" [programRulesLink]="programRulesLink" [programFAQLink]="programFAQLink" [tokenLabelSingular]="userOptedInProgram.tokenLabelSingular" [tokenLabelPlural]="userOptedInProgram.tokenLabelPlural" [userInfo]="userInfo"></game-card>
                </ng-container>
                
            </ng-container>
        </ng-container>
        <ng-container *ngIf="activeMode == 'maintenance'">
            <div tabindex="0" aria-label="Games page is currently in maintenance mode"  class="message noGameContainer">
                <p class="noGameImg text-center mt-32 mb-16 p-16"><img src="/content/dam/games/trophy.svg"></p>
                <p class="noGameMessage text-center title-md-bold center">We're sorry, but the games are currently down for maintenance.</p>
                <p class="noGameMessage text-center title-md-bold center">Check back later for more exciting opportunities to win!</p>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #invalidStore>
    <div class="episodic-header">
        <button id="invalid-store-close" type="button" class="close" data-dismiss="modal" aria-label="Close Invalid Store Dialog" data-tabindex="first" (click)="invalidStoreRef.hide();analyticsModalTracking('not-available-at-this-store|close','click')">
            <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
        </button>
    </div>
    <div class="episodic-game-logo">
        <picture>
            <source media="(min-width: {{md}})" srcset="{{getIconImageUrl(message.gameId,'desktop')}}">
            <source media="(min-width: {{sm}})" srcset="{{getIconImageUrl(message.gameId,'tablet')}}">
            <img class="episodic-game-logo" loading="lazy" role="presentation" src="{{getIconImageUrl(message.gameId, 'mobile')}}" alt=""/>
        </picture>
    </div>
    <div class="episodic-body pl-4 pr-4">
        <div id="invalid-store-headline" class="title-lg-bold episodic-body__title">
            {{message.gameName}} is not available at this store
        </div>
        <div class="episodic-body__text">
            <a href="{{message.rulesLink}}" target="_blank" class="episodic-body__text__clickHere" [attr.aria-label]="'Click here for a list of participating stores'">Click here</a> for a list of
            participating stores.
        </div>
    </div>
    <div class="episodic-footer pt-3 pb-4 pl-4 pr-4">
        <button (click)="showStorePicker()" class="btn btn-xl btn-primary body-text episodic-footer__button"
            aria-label="click to change stores to continue playing" data-tabindex="last">Change stores to
            continue playing</button>
    </div>
</ng-template>
<ng-template #sweepstakesWinner>
    <div class="episodic-header">
        <button id="sweepstakes-winner-close" type="button" class="close" data-dismiss="modal" aria-label="Close Sweepstakes Winner notification dialog" data-tabindex="first" (click)="sweepstakesWinnerRef.hide()">
            <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
        </button>
    </div>
    <div class="episodic-game-logo">
        <picture>
            <source media="(min-width: {{md}})" srcset="{{getSweepstakesImgUrl(sweepstakesWinners[0].prizeId,'desktop')}}">
            <source media="(min-width: {{sm}})" srcset="{{getSweepstakesImgUrl(sweepstakesWinners[0].prizeId,'tablet')}}">
            <img class="episodic-game-logo" loading="lazy" role="presentation" src="{{getSweepstakesImgUrl(sweepstakesWinners[0].prizeId, 'mobile')}}" alt=""/>
        </picture>
    </div>
    <div class="episodic-body pl-4 pr-4">
        <div id="sweepstakes-winner-headline" class="title-lg-bold episodic-body__title">
            {{sweepstakesHeadline}}
        </div>
        <div class="episodic-body__text ">
            You're a potential winner of {{sweepstakesWinners[0].prizeName}}! Check your email ({{getEmailId()}}) for more details  
        </div>
    </div>
    <div class="episodic-footer pt-3 pb-4 pl-4 pr-4">
        <button class="btn btn-xl btn-primary body-text episodic-footer__button" 
            [attr.aria-label]="sweepstakesCTA" (click)="acknowledgeSweepstakesWin()" 
            data-tabindex="last">{{sweepstakesCTA}}</button>
    </div>
</ng-template>
<ng-template #serviceErrorPopup>
    <div class="episodic-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-tabindex="first" (click)="serviceErrorPopupRef.hide()">
            <span class="svg-icon svg-close-grey episodic-modal-close" aria-hidden="true"></span>
        </button>
    </div>
    <div class="episodic-warning">
        <span class="svg-warning-outline"></span>
    </div>
    <div class="episodic-body pl-4 pr-4">
        <div class="title-lg-bold episodic-body__title">
            There was an issue
        </div>
        <div class="episodic-body__text">
            There was a technical issue. Please retry
        </div>
    </div>
    <div class="episodic-footer pt-3 pb-4 pl-4 pr-4">
        <button class="btn btn-xl btn-primary body-text episodic-footer__button" aria-label="Retry" data-tabindex="last" (click)="serviceErrorPopupRef.hide(); getGamesInfo()">Retry</button>
    </div>
</ng-template>
